import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { Search as SearchIcon } from 'lucide-react';
import { POSTS, USERS } from '@/shared/data';
import { SmartImage } from '@/shared/ui/SmartImage';

const RECENT = ['editorial', 'noir', 'studio', 'linen'];

export function Search() {
  const [q, setQ] = useState('');
  const filtered = useMemo(() => {
    const term = q.trim().toLowerCase();
    if (!term) return POSTS;
    return POSTS.filter(
      (p) =>
        p.caption.toLowerCase().includes(term) ||
        p.tags.some((t) => t.toLowerCase().includes(term)) ||
        USERS.find((u) => u.id === p.authorId)?.username
          .toLowerCase()
          .includes(term),
    );
  }, [q]);

  return (
    <div data-testid="instaflix-search">
      <div className="px-4 pb-3">
        <div className="glass rounded-full flex items-center gap-2 px-4 py-2.5">
          <SearchIcon className="w-4 h-4 text-white/40" />
          <input
            data-testid="search-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search Instaflix"
            className="bg-transparent flex-1 outline-none text-sm placeholder:text-white/40"
          />
        </div>
      </div>
      {!q && (
        <div className="px-4 pb-3">
          <div className="text-[11px] uppercase tracking-widest text-white/40 mb-2">
            Recent
          </div>
          <div className="flex gap-2 flex-wrap">
            {RECENT.map((r) => (
              <button
                key={r}
                onClick={() => setQ(r)}
                className="glass px-3 py-1.5 rounded-full text-xs text-white/80"
              >
                {r}
              </button>
            ))}
          </div>
        </div>
      )}
      <div className="grid grid-cols-3 gap-[2px]">
        {filtered.map((p) => (
          <Link
            key={p.id}
            to={`/instaflix/post/${p.id}`}
            className="relative aspect-square overflow-hidden bg-black/30"
          >
            <SmartImage fill src={p.media[0]} alt={p.caption} sizes="33vw" />
          </Link>
        ))}
      </div>
    </div>
  );
}
